import api from '../utils/api';
import { normalizeApiResponse } from '../utils/apiResponseHandler';

// Feature service for API calls
export const featureService = {
  // Get all features with query parameters
  getFeatures: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      Object.keys(params).forEach(key => {
        if (params[key] !== undefined && params[key] !== '') {
          queryParams.append(key, params[key]);
        }
      });
      const response = await api.get(`/admin/features?${queryParams.toString()}`);
      return normalizeApiResponse(response, 'features');
    } catch (error) {
      throw error;
    }
  },

  // Get single feature by ID
  getFeature: async (featureId) => {
    try {
      const response = await api.get(`/admin/features/${featureId}`);
      return normalizeApiResponse(response);
    } catch (error) {
      throw error;
    }
  },

  // Create new feature
  createFeature: async (featureData) => {
    try {
      const response = await api.post('/admin/features', featureData);
      return normalizeApiResponse(response);
    } catch (error) {
      throw error;
    }
  },

  // Update feature
  updateFeature: async (featureId, featureData) => {
    try {
      const response = await api.put(`/admin/features/${featureId}`, featureData);
      return normalizeApiResponse(response);
    } catch (error) {
      throw error;
    }
  },

  // Delete feature
  deleteFeature: async (featureId) => {
    try {
      const response = await api.delete(`/admin/features/${featureId}`);
      return normalizeApiResponse(response);
    } catch (error) {
      throw error;
    }
  }
};

export default featureService;